$(window).load(function () {
	$('.flexslider').flexslider({
		animation: 'slide',
		slideshowSpeed: 5e3,
		controlNav: !1,
		directionNav: !0,
		prevText: '',
		nextText: '',
	});
});

$(function () {
	var flashMessage = document.getElementById('alert-box');
	if (flashMessage && flashMessage.classList.contains('info')) {
		setTimeout(function () {
			$('#alert-box').hide();
		}, 8000);
	}

	$('.store-select').selectric();
});

jQuery(function (e) {
	e('.navbar .dropdown').hover(
		function () {
			e(this)
				.find('.dropdown-menu')
				.first()
				.stop(!0, !0)
				.delay(100)
				.slideDown();
		},
		function () {
			e(this)
				.find('.dropdown-menu')
				.first()
				.stop(!0, !0)
				.delay(100)
				.slideUp();
		}
	),
		e('.navbar .dropdown > a').click(function () {
			location.href = this.href;
		});
}),
	Function('/*@cc_on return document.documentMode===10@*/')() &&
		$('html').addClass('ie10'),
	jQuery(window).load(function () {
		navigator.userAgent.match(/Trident.*rv:11\./) &&
			jQuery('html').addClass('ie11');
	}),
	$(document).ready(function () {
		$('.fancybox').fancybox();
	}),
	$(document).ready(function () {
		$('ul#nav-sub li ul').hide(),
			$('ul#nav-sub li:has(ul)').hover(function () {
				$(this).find('ul').stop(!0, !0).slideToggle(),
					$(this).find('ul').addClass('list-unstyled');
			});
	}),
	$('.year-block').click(function () {
		$(this).children('.month-wrap').toggleClass('open'),
			$(this).toggleClass('hover'),
			$(this).siblings().removeClass('hover'),
			$(this).siblings().children('.month-wrap').removeClass('open');
	}),
	$(function () {
		$(window).click(function () {
			$('a[data-popover="toggle"]').removeClass('active');
		}),
			$(document).on('click', 'a[data-popover="toggle"]', function (e) {
				e.preventDefault(),
					e.stopPropagation(),
					$(this).toggleClass('active');
			}),
			$(document).on('click', 'a[data-popover="close"]', function (e) {
				e.preventDefault(),
					e.stopPropagation(),
					$(this)
						.parents('.popover')
						.prev('a[data-popover="toggle"]')
						.toggleClass('active');
			});
	}),
	$('#ct-debug-toggle').on('click', function () {
		$(this).toggleText('Hide', 'Show'),
			$('#ct-debug').find('pre').toggle(),
			$('#ct-debug').toggleClass('active');
	}),
	$.fn.extend({
		toggleText: function (e, n) {
			return this.text(this.text() == n ? e : n);
		},
	}),
	$(function () {
		if ($('#ct-debug').length) {
			var e = $('#ct-debug').find('pre').text(),
				n = JSON.parse(e);
			$('#ct-debug').find('pre')[0].innerHTML = JSON.stringify(
				n,
				void 0,
				2
			);
		}
	});

function toggleNav() {
	$('.navbar-content').slideToggle();
}

$(window).resize(function () {
	var width = $(window).width();

	if (width > 976) {
		$('.navbar-content').removeAttr('style');
	}
});

$(function () {
	var quote = $('#quote-request-form');


	if (quote.length > 0) {
		quote.find('tr').each(function () {
			var index = $(this).index();
			index = index + 1;
			index = index.toString();
			var td = $(this).find('td:first-of-type');
			td.prepend('<span>' + index + '</span>');
		});

		var form = document.getElementById('quote-form');
		form.addEventListener(
			'freeform-field-table-after-row-added',
			function (event) {
				var form = event.form;
				var freeform = event.freeform;

				var table = event.table; 
				var row = event.row; 

				$.fn.matchHeight._update();
				quote.find('tr').each(function () {
					var index = $(this).index();
					index = index + 1;
					index = index.toString();
					var td = $(this).find('td:first-of-type');
					td.find('span').text(index);
				});
			}
		);

		form.addEventListener(
			'freeform-field-table-after-remove-row',
			function (event) {
				var form = event.form;
				var freeform = event.freeform;

				var table = event.table; 

				$.fn.matchHeight._update();
				quote.find('tr').each(function () {
					var index = $(this).index();
					index = index + 1;
					index = index.toString();
					var td = $(this).find('td:first-of-type');
					td.find('span').text(index);
				});
			}
		);
	}
});


$(function () {
	var width = window.innerWidth;
	var mobile = width < 768;

	var storeSidebar = $('#store-sidebar');
	if (
		(Cookies.get('sidebarOpen') == 1 ||
			Cookies.get('sidebarOpen') === undefined) &&
		!mobile
	) {
		$('.collapsible-sidebar').addClass('open');
		$('#content-area').addClass('sidebar-open');
		setContentSpacing();
	}

	if (storeSidebar.length > 0) {
		var url = $(location).attr('href').split('/');

		$('#' + url[3])
			.find('.top-trigger-wrapper')
			.addClass('open');
		$('#' + url[3])
			.find('.second-menu')
			.slideDown();
		$('#' + url[5])
			.children('.third-menu')
			.slideDown();
		$('#' + url[5])
			.find('.sec-trigger-arrow')
			.addClass('open');
	}

	var blogSidebar = $('#blog-sidebar');

	if (blogSidebar.length > 0) {
		var url = $(location).attr('href').split('/');
		$('#' + url[5] + '-menu')
			.find('.top-trigger-wrapper')
			.addClass('open');
		$('#' + url[5] + '-menu')
			.find('.second-menu')
			.slideDown();
	}
});

$('#sidebar-toggle').click(function (e) {
	e.preventDefault();
	$('.collapsible-sidebar').addClass('open');
	$('#content-area').addClass('sidebar-open');
	Cookies.set('sidebarOpen', 1);
	setContentSpacing();
});

$('.top-trigger').click(function (e) {
	$('.top-trigger')
		.not(this)
		.parents('.top-trigger-wrapper')
		.siblings('.second-menu')
		.slideUp();
	$('.top-trigger')
		.not(this)
		.parents('.top-trigger-wrapper')
		.removeClass('open');
	$(this).parents('.top-trigger-wrapper').toggleClass('open');
	$(this)
		.parents('.top-trigger-wrapper')
		.siblings('.second-menu')
		.slideToggle();
});

$('.sec-trigger').click(function (e) {
	$('.third-menu').slideUp();
	$(this).siblings('.third-menu').slideToggle();
});

$('.sec-trigger-arrow').click(function (e) {
	var $current = $(this)
		.parents('.sec-trigger-wrapper')
		.siblings('.third-menu');
	$('.third-menu').not($current).slideUp();
	$('.sec-trigger-arrow').not(this).removeClass('open');
	$current.slideToggle();
	$(this).toggleClass('open');
});

function collapseSidebar() {
	$('.collapsible-sidebar').removeClass('open');
	$('#content-area').removeClass('sidebar-open');
	$('.content-wrap').children('section').removeAttr('style');
	$('#search').removeAttr('style');
	$('.top-trigger').removeClass('open');
	$('.second-menu').slideUp();
	$('.third-menu').slideUp();
	Cookies.set('sidebarOpen', 0);
}

function setContentSpacing() {
	var sidebar = $('.collapsible-sidebar').innerWidth();
	var content = $('#content-area').innerWidth();
	var wrap = $('.content-wrap');
	var breadcrumb = $('ol.breadcrumb').innerWidth();
	$('#search').css('padding-left', sidebar - breadcrumb + 15);
	wrap.children('section').css('max-width', content - sidebar - 40);
}

$(window).resize(function () {
	var content = $('#content-area');

	if (content.hasClass('sidebar-open')) {
		setContentSpacing();
	}
});

$('.account-trigger').click(function () {
	$(this).addClass('active');
});

document.querySelector('.account-button') ? document.querySelector('.account-button').addEventListener('keydown', (e) => {
	if (e.key == "Enter") {
		toggleAcctMenu()
	}
}) : null

function toggleAcctMenu() {
	const actBtn = document.querySelector('.account-button')
	const actMenu = document.querySelector('.account-trigger')
	if (actBtn && actMenu) {
		actBtn.addEventListener('click', (e) => {
			if (actMenu.classList.contains('active')) {
				actBtn.setAttribute('aria-expanded', false)
				actMenu.classList.remove('active')
			} else {
				actBtn.setAttribute('aria-expanded', true)
				actMenu.classList.add('active')
			}
		})
	}
}

$(document).click(function (event) {
	var $target = $(event.target);
	if (!$target.closest('.account-trigger').length) {
		$('.account-trigger').removeClass('active');
	}
});

$('.i').click(function () {
	$(this).parent().find('.info-popup').toggle();
});
